@if (isMobile() && isReels()) {
  <app-home-reels></app-home-reels>
} @else {
  <app-home></app-home>
}
